import { AuthenticatedTemplate } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { Container, Button } from 'react-bootstrap';
import { IdTokenData } from '../components/DataDisplay';
import { Link } from 'react-router-dom';
import './Home.css';

/***
 * Component to detail ID token claims with a description for each claim. For more details on ID token claims, please check the following links:
 * ID token Claims: https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token
 * Optional Claims:  https://docs.microsoft.com/en-us/azure/active-directory/develop/active-directory-optional-claims#v10-and-v20-optional-claims-set
 */
export const Home = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    return (
        <>
            <AuthenticatedTemplate>
                {activeAccount ? (
                    <Container>
                        {/*<IdTokenData idTokenClaims={activeAccount.idTokenClaims} />*/}
                        <div className="button-container">
                            <Link to="/showUsers" className="btn btn-primary custom-button">
                                Show Users
                            </Link>
                            {/*<Link to="/addUsers" className="btn btn-primary custom-button">
                                Add Users
                            </Link>*/}
                        </div>
                        
                    </Container>
                ) : null}
            </AuthenticatedTemplate>
        </>
    );
};